import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4bb55154")

_pushScopeId("data-v-4bb55154")
const _hoisted_1 = { class: "select-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "form-label" }, "onlylive利用国", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("select", {
      class: "select-box",
      value: _ctx.modelValue,
      onInput: _cache[1] || (_cache[1] = (event) => _ctx.$emit('update:modelValue', event.target.value))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createBlock("option", {
          value: option.value
        }, _toDisplayString(option.text), 9, ["value"]))
      }), 256))
    ], 40, ["value"])
  ]))
})